import React from "react";

/**
 * RowHeader
 * Leftmost <th> of each row — the 1-based row number plus a row-resize
 * handle.  The TH itself carries sticky-left positioning; the visible
 * label is wrapped in a flex span so it can stay vertically centred
 * inside the row's height (see GridCell.jsx for the full reasoning on
 * why visible content lives in an inner element rather than directly
 * on the TH).
 */
function RowHeader({ rowIndex, rowHeight, className, style, onSelect, onExtend, onContextMenu, onStartResize }) {
  return (
    <th
      className={className}
      style={{ height: rowHeight + "px", ...style }}
      onMouseDown={(e) => { if (e.button === 0) onSelect(rowIndex, e); }}
      onMouseEnter={() => onExtend(rowIndex)}
      onContextMenu={onContextMenu}
    >
      <span
        className="simple-excel-row-header-content"
        style={{ height: rowHeight + "px" }}
      >
        {rowIndex + 1}
      </span>
      <span
        className="sev-resize-row"
        onMouseDown={(event) => onStartResize("row", rowIndex, event)}
      />
    </th>
  );
}

export default React.memo(RowHeader);
